export default __webpack_public_path__ + "static/media/notification.e4967cdd.wav";